import AssignPublicRetailerAccountModal from './AssignPublicRetailerAccountModal.container'

export default AssignPublicRetailerAccountModal
